import { SVGProps } from "react";

const HongKong = (props: SVGProps<SVGSVGElement>) => {
  const { width = 24, height = 24 } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill="#D80027"
      />
      <path
        d="M13.0321 9.56498C12.8048 10.5103 12.4011 10.33 12.2029 11.1544C11.0356 10.8737 10.3167 9.69987 10.5973 8.53248C10.8779 7.36518 12.0518 6.64627 13.2192 6.92694C12.8228 8.57565 13.2354 8.71955 13.0321 9.56498Z"
        fill="#F8F9F9"
      />
      <path
        d="M10.0031 10.2655C10.8319 10.7737 10.5357 11.1021 11.2584 11.5454C10.6307 12.5688 9.29227 12.8897 8.26876 12.2621C7.24528 11.6345 6.9243 10.2959 7.55196 9.27246C8.99751 10.1589 9.26177 9.81094 10.0031 10.2655Z"
        fill="#F8F9F9"
      />
      <path
        d="M9.73353 13.3628C10.473 12.7316 10.6937 13.1148 11.3386 12.5645C12.1181 13.4776 12.0096 14.8498 11.0965 15.6293C10.1833 16.4088 8.81111 16.3002 8.03174 15.3871C9.32135 14.2862 9.07209 13.9273 9.73353 13.3628Z"
        fill="#F8F9F9"
      />
      <path
        d="M12.5954 14.5767C12.2236 13.6784 12.6562 13.5868 12.332 12.8035C13.4414 12.3444 14.7129 12.8715 15.1721 13.9808C15.6312 15.0902 15.104 16.3617 13.9946 16.8208C13.3463 15.2541 12.928 15.3802 12.5954 14.5767Z"
        fill="#F8F9F9"
      />
      <path
        d="M14.6345 12.2294C13.6652 12.3055 13.7117 11.8656 12.8666 11.9319C12.7728 10.7351 13.6671 9.68858 14.864 9.59463C16.0608 9.50092 17.1073 10.3951 17.2012 11.5921C15.5107 11.7246 15.5013 12.1615 14.6345 12.2294Z"
        fill="#F8F9F9"
      />
    </svg>
  );
};

export default HongKong;
